import { EventAnalyticsDailyRevenueDto } from 'legacy/events/types';

import { useQuery } from 'react-query';
import { ErrorResponse } from 'legacy/common/utils/error';
import { getEventAnalyticsRevenueDaily } from '../service';

export function useGetEventAnalyticsRevenueDaily({
  eventId
}: {
  eventId: string;
}) {
  return useQuery<EventAnalyticsDailyRevenueDto, ErrorResponse>(
    ['data', { eventId }],
    () => getEventAnalyticsRevenueDaily({ eventId })
  );
}
